import type { HomepageLayoutContent } from '../components/sections/sectionRegistry';
import {
  DEFAULT_INTRO_LAYOUT_CONTENT,
  ensureIntroPageLayout,
  INTRO_PAGE_KEY,
} from './introPage';
import {
  DEFAULT_EVENTS_LAYOUT_CONTENT,
  ensureEventsPageLayout,
  EVENTS_PAGE_KEY,
} from './eventsPage';
import {
  DEFAULT_HOLDING_LAYOUT_CONTENT,
  ensureHoldingPageLayout,
  HOLDING_PAGE_KEY,
} from './holdingPage';
import {
  DEFAULT_SNAP_FIXTURE_LAYOUT_CONTENT,
  ensureSnapFixturePageLayout,
  SNAP_FIXTURE_PAGE_KEY,
} from './snapFixturePage';

export const CORE_PAGE_KEYS = ['home', INTRO_PAGE_KEY, EVENTS_PAGE_KEY, HOLDING_PAGE_KEY] as const;

export function isReservedPageKey(pageKey: string) {
  return CORE_PAGE_KEYS.includes(pageKey as (typeof CORE_PAGE_KEYS)[number]);
}

export async function ensureCorePageLayouts() {
  await ensureIntroPageLayout();
  await ensureEventsPageLayout();
  await ensureHoldingPageLayout();
  await ensureSnapFixturePageLayout();
}

export function getCorePageFallback(pageKey: string): HomepageLayoutContent | null {
  if (pageKey === INTRO_PAGE_KEY) return DEFAULT_INTRO_LAYOUT_CONTENT;
  if (pageKey === EVENTS_PAGE_KEY) return DEFAULT_EVENTS_LAYOUT_CONTENT;
  if (pageKey === HOLDING_PAGE_KEY) return DEFAULT_HOLDING_LAYOUT_CONTENT;
  if (pageKey === SNAP_FIXTURE_PAGE_KEY) return DEFAULT_SNAP_FIXTURE_LAYOUT_CONTENT;
  return null;
}
